import { createApiEnumAction } from 'pmt-modules/api/utils'
import { isOrderPlugin, isKiosk, isWebCustomer, isBo, isWebGlobal } from 'pmt-modules/environment'
import { getStore } from 'pmt-modules/store'
import { createAction } from '../redux'

export const I18nFetchingLocale = createApiEnumAction('I18n::FETCHING_LOCALE')

// the require.context is needed for webpack to bundle translation files
// without it, the translation are not loaded when the app is hosted on a custom domain and displayed via iframe
// eg. the translations were not loaded on https://order.preprod.leon-de-bruxelles.paymytable.com/restaurant/17000107/catalog
// despite being loaded on https://order2.pluginweb.preprod.paymytable.com/restaurant/17000107/catalog?apiConsumer=NTY4MTEzNDk5MDAwMDEyODpBTnc0VkZlODNqMFpiZw==
// Vite alternative to require.context is import.meta.glob
const translationsContext = import.meta.glob(
  '/pmt-react-sdk/packages/modules/src/i18n/labels/**/*.json',
  {
    eager: true,
  }
)

async function loadTranslationFile(locale) {
  const appName =
    isOrderPlugin()
      ? 'pmt-order-plugin'
      : isWebCustomer()
        ? 'pmt_web_customer'
        : isKiosk()
          ? 'pmt-web-kiosk'
          : isBo()
            ? 'pmt-backoffice'
            : isWebGlobal()
              ? 'pmt-web-global'
              : null

  return loadTranslationFileForApp(appName, locale)
}

export async function loadTranslationFileForApp(appName, locale) {
  if (!appName) {
    console.error(`Unknown webapp: cannot determine appName to load the translations`)
    throw new Error('Unknown webapp: cannot determine appName to load the translations')
  }

  const fileKey = `/pmt-react-sdk/packages/modules/src/i18n/labels/${appName}/${locale}.json`
  const module = translationsContext[fileKey]

  if (!module) {
    const error = new Error(`Translation file not found: ${fileKey}`)
    console.error(error)
    throw error
  }

  return module.default || module
}

export const retrieveMessages = languageParam => {
  const locale = languageParam === 'debug' ? 'en' : languageParam

  getStore().dispatch({
    type: I18nFetchingLocale.REQUEST,
    locale: locale,
  })

  loadTranslationFile(locale)
    .then(labels => {
      getStore().dispatch({
        type: I18nFetchingLocale.SUCCESS,
        locale: locale,
        phrases: labels,
      })
    })
    .catch(err => {
      console.log('[i18n] retrieveMessages FAILURE for locale:', locale, err)
      getStore().dispatch({
        type: I18nFetchingLocale.FAILURE,
        locale: locale,
      })
    })
}

//
//
//

export const CHOOSE_LOCALE = 'I18n::CHOOSE_LOCALE'

export const chooseLocale = locale => createAction(CHOOSE_LOCALE, { locale })
